import React, {
  Fragment, useEffect, useState,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Popconfirm, Drawer,
} from 'antd';
import PropTypes from 'prop-types';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import TenantActions from '@Actions/tenantActions';
import UserActions from '@Actions/userActions';
import H3Text from '@Uilib/h3Text';
import {
  EditOutlined, DeleteOutlined,
} from '@ant-design/icons';
import MaskingPolicyActions from '@Actions/settings/maskingPolicyActions';
import Helpers from '@Apis/helpers';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import MaskingPolicyForm from './MaskingPolicyForm';
import Lottie from 'lottie-react';
import restrictedLock from '../../../../../media/lotties/restrictedLock.json';

import './style.scss';

/**
 *
 */
const ListMaskingPolicies = ({
  user, getMaskingPolicies, maskingPolicies, deleteMaskingPolicy, getMaskingPoliciesLoading, deleteMaskingPolicyLoading, getUserProfile,
}) => {
  const [showAddMaskingPolicyModal, setShowAddMaskingPolicyModal] = useState(false);
  const [showUpdateMaskingPolicyModal, setShowUpdateMaskingPolicyModal] = useState(false);
  const [selectedMaskingPolicy, setSelectedMaskingPolicy] = useState(false);
  const [call, setCall] = useState(false);

  const columns = [
    {
      title: 'POLICY NAME',
      render: (text, record) => (
        <H3Text text={`${record?.data_masking_policy_name}`} />
      ),
      responsive: ['sm', 'md', 'lg', 'xxl', 'xs'],
    },
    {
      title: '',
      render: (text, record) => (
        <div className="list__actions-column">
          <div className="list__actions">
            {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP, Helpers.permissionTypes.UPDATE, user) && (
              <div
                className="roundIconButton"
                onClick={() => {
                  setShowUpdateMaskingPolicyModal(true);
                  setSelectedMaskingPolicy(record);
                }}
              >
                <EditOutlined />
              </div>
            )}
            {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP, Helpers.permissionTypes.DELETE, user) && (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this masking policy?"
                onConfirm={() => deleteMaskingPolicy({
                  data_masking_policy_id: record?.data_masking_policy_id,
                }, () => {
                  setCall(!call);
                })}
                okText="Yes"
                cancelText="No"
              >
                <div
                  className="deleteButton"
                >
                  <DeleteOutlined />
                </div>
              </Popconfirm>
            )}
          </div>
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
  ];

  useEffect(() => {
    getMaskingPolicies(user?.tenant_info?.org_id, null, null, null);
  }, []);

  useEffect(() => {
    getMaskingPolicies(user?.tenant_info?.org_id, null, null, null);
  }, [call]);

  const dataMasking = user?.tenant_info?.global_config?.sub_modules?.data_masking?.is_active;

  return (
    <Fragment>
      <Drawer
        open={showAddMaskingPolicyModal}
        onClose={() => setShowAddMaskingPolicyModal(false)}
        width="650px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '600px' }}>
            <H3Text text="Add Masking Policy" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowAddMaskingPolicyModal(false)} />
          </div>
        </div>
        <MaskingPolicyForm
          callback={() => {
            setShowAddMaskingPolicyModal(false);
            setCall(!call);
          }}
        />
      </Drawer>
      <Drawer
        open={showUpdateMaskingPolicyModal}
        onClose={() => setShowUpdateMaskingPolicyModal(false)}
        destroyOnClose
        width="650px"
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '600px' }}>
            <H3Text text="Update Masking Policy" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateMaskingPolicyModal(false)} />
          </div>
        </div>
        <MaskingPolicyForm
          callback={() => {
            setShowUpdateMaskingPolicyModal(false);
            setCall(!call);
            getUserProfile();
          }}
          selectedMaskingPolicy={selectedMaskingPolicy}
        />
      </Drawer>
      <div className="masking-policies-list__wrapper doc-list__wrapper doc-list__tab-content">
        {!dataMasking && (
          <div className="restrict-masking-policies__wrapper">
            <div className="restrict-masking-policies-overlay">
              <div className="restrict-masking-policies-content__wrapper">
                <div className="restrict-masking-policies-content">
                  <div className="restrict-masking-policies-lock__wrapper">
                    <div className="restrict-masking-policies-lock">
                      <Lottie
                        animationData={restrictedLock}
                        loop
                      />
                    </div>
                  </div>
                  <div className="restrict-masking-policies-text-head">Premium Feature</div>
                  <div className="restrict-masking-policies-text-body">
                    Data Masking feature is not available in your current plan.
                  </div>
                  <div className="restrict-masking-policies-contact-button__wrapper">
                    <div
                      className="restrict-masking-policies-contact-button"
                      onClick={() => window.Intercom('showNewMessage')}
                    >
                      Contact Us
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="ant-row">
          <div className="ant-col-md-12 ant-col-xs-24">
            <div className="doc-list__table-wrapper show-table-header-in-mobile">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      {`${maskingPolicies?.data?.length || '0'} User Policies`}
                    </div>
                    <div className="doc-list__table-header__right">
                      {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP, Helpers.permissionTypes.CREATE, user) && (
                        <div className="doc-list__buttons-wrapper">
                          <H3Button
                            buttonType={defaultButtonTypes.BLUE_ROUNDED}
                            text="+ Add Masking Policy"
                            onClick={() => setShowAddMaskingPolicyModal(true)}
                            customClass="add-button"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
                showHeader
                loading={getMaskingPoliciesLoading || deleteMaskingPolicyLoading}
                size="small"
                columns={columns}
                dataSource={maskingPolicies?.data || []}
                currentPage
                pagination={maskingPolicies?.data?.length > 10 ? {
                  defaultCurrent: 1,
                  pageSize: 10,
                  position: ['bottomRight'],
                  showSizeChanger: false,
                } : false}
                bordered
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, TenantReducers, MaskingPolicyReducers,
}) => ({
  user: UserReducers.user,
  roles: UserReducers.roles,
  maskingPolicies: MaskingPolicyReducers.maskingPolicies,
  getMaskingPoliciesLoading: MaskingPolicyReducers.getMaskingPoliciesLoading,
  deleteMaskingPolicyLoading: MaskingPolicyReducers.deleteMaskingPolicyLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: (tenantId, roleId) => dispatch(TenantActions.getUsers(tenantId, roleId)),
  getRoles: (tenantId) => dispatch(UserActions.getRoles(tenantId)),
  updateUser: (payload, callback) => dispatch(UserActions.updateUser(payload, callback)),
  deleteMaskingPolicy: (payload, callback) => dispatch(MaskingPolicyActions.deleteMaskingPolicy(payload, callback)),
  getMaskingPolicies: (orgId, maskingPolicyId, page, limit, callback) => dispatch(MaskingPolicyActions.getMaskingPolicies(orgId, maskingPolicyId, page, limit, callback)),
  getUserProfile: (callback) => dispatch(UserActions.getUserProfile(callback)),
});

ListMaskingPolicies.propTypes = {
  user: PropTypes.func,
  getUsers: PropTypes.func,
  getUsersLoading: PropTypes.bool,
  users: PropTypes.any,
  updateUserLoading: PropTypes.bool,
  updateUser: PropTypes.func,
  getRoles: PropTypes.func,
  maskingPolicies: PropTypes.any,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListMaskingPolicies));
